module.exports = __webpack_public_path__ + "static/img/image_object.274adc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home/image_object.jpg
// module id = sZ/n
// module chunks = 2